// Shared `*.pageTitle` i18n keys for authentication and error pages.
// All of these are read dynamically from `route.meta.pageTitle` strings in
// router.ts and resolved at runtime by PageTitle.vue.

export const authDict: Record<string, [en: string, th: string]> = {
  // ── Auth pages ──────────────────────────────────────────
  "SignIn.pageTitle": ["Sign In", "เข้าสู่ระบบ"],
  "Logon.pageTitle": ["Logon", "เข้าสู่ระบบ"],
  "AcceptInvite.pageTitle": ["Accept Invitation", "ยอมรับคำเชิญ"],
  "DebugLogin.pageTitle": ["Debug Login", "ดีบักการเข้าสู่ระบบ"],
  "OAuthCallback.pageTitle": ["OAuth Callback", "การยืนยัน OAuth"],

  // ── Error pages ─────────────────────────────────────────
  "Error404.pageTitle": ["Error 404", "ข้อผิดพลาด 404"],
  "Error403.pageTitle": ["Access Denied", "ปฏิเสธการเข้าถึง"],
  "Error500.pageTitle": ["Error 500", "ข้อผิดพลาด 500"],
};
